<div>
    <p>Send {{ title }} to patient?</p>
    <button type="button" class="btn btn-default mr-2" (click)="confirm()" >Yes</button>
    <button type="button" class="btn btn-primary" (click)="decline()" >No</button>
</div>